"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.batteryConfig = void 0;
exports.batteryConfig = {
    name: 'battery',
    fullname: 'Battery',
    description: 'Stores excess energy. No energy is lost in the process.',
    type: 'storage',
    width: 1,
    height: 1,
    levelMax: 8,
    canBeDisabled: false,
    requiredTechnology: 'stone',
    levels: [
        { level: 0, constructionCosts: {}, time: 1, provides: {}, costs: {}, stores: { energy: 3 } },
        { level: 1, constructionCosts: { energy: 10 }, time: 1, provides: {}, costs: {}, stores: { energy: 5 } },
        { level: 2, constructionCosts: { energy: 20 }, time: 1, provides: {}, costs: {}, stores: { energy: 10 } },
        { level: 3, constructionCosts: { energy: 30, stone: 10 }, time: 1, provides: {}, costs: {}, stores: { energy: 20 } },
        { level: 4, constructionCosts: { energy: 50, stone: 10, iron: 10 }, time: 1, provides: {}, costs: {}, stores: { energy: 40 } },
        { level: 5, constructionCosts: { energy: 120, stone: 50, iron: 100, copper: 100 }, time: 1, provides: {}, costs: {}, stores: { energy: 80 } },
        { level: 6, constructionCosts: { energy: 240, stone: 100, iron: 1000, copper: 1000 }, time: 1, provides: {}, costs: {}, stores: { energy: 150 } },
        { level: 7, constructionCosts: { energy: 620, stone: 300, iron: 2000, copper: 1000, gold: 50 }, time: 1, provides: {}, costs: {}, stores: { energy: 300 } },
        { level: 8, constructionCosts: { energy: 1020, stone: 600, iron: 3000, copper: 1000, gold: 200 }, time: 1, provides: {}, costs: {}, stores: { energy: 500 } },
    ],
};



//////////////////
// WEBPACK FOOTER
// ../engine/dist/config/buildings/battery.js
// module id = 0Km7
// module chunks = 0